import React from "react";
import { useDetailSidebarContext } from "@src/lib/contexts/DetailSidebarContext";
import { DetailSidebarRenderer } from "./DetailSidebarRenderer";

const DetailSidebarContainer: React.FC = () => {
  const { objectId, sidebarType } = useDetailSidebarContext();

  // If no sidebar is open, show placeholder
  if (!objectId || !sidebarType) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="space-y-2 text-center">
          <div className="text-sm text-muted-foreground">
            Select a row to view details
          </div>
        </div>
      </div>
    );
  }

  return (
    <DetailSidebarRenderer
      sidebarType={sidebarType}
      objectId={objectId}
      showHeader={true}
    />
  );
};

export default DetailSidebarContainer;
